import { createContext, useContext } from 'react'

type VesselLandingContextValue = {
  openVesselLanding: (vesselId: number) => void
  closeVesselLanding: () => void
  activeVesselId: number | null
}

const VesselLandingContext = createContext<VesselLandingContextValue | null>(null)

export const useVesselLanding = (): VesselLandingContextValue => {
  const context = useContext(VesselLandingContext)
  if (!context) {
    throw new Error('useVesselLanding must be used within VesselLandingProvider')
  }
  return context
}

export default VesselLandingContext
